export class LoggerService {
	constructor(Api) {
		'ngInject';
		this.Api = Api;
	}

	write(severity, message, data = {}) {
		data.appVersion = this.getAppVersion();
		const json = JSON.stringify(data);
		if (json.length > 7000) {
			// don't let data payload get too big
			data = json.slice(0, 7000) + '...';
		}
		return this.Api.post(
			'/ulog/write',
			{
				severity,
				message: String(message),
				data,
			},
			{
				Authorization: 'Public',
				avoidLoadingBar: true,
			}
		);
	}

	getAppVersion() {
		if (navigator.appInfo) {
			const v = navigator.appInfo;
			return `Sharpr Mobile v${v.version} build ${v.build}`;
		} else {
			return 'Sharpr Mobile v-local';
		}
	}
}
